export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"lomadee-verification","content":"23094017"}],"link":[{"rel":"icon","type":"image/png","href":"/favicon/logo-square-16x16.png","sizes":"16x16"},{"rel":"icon","type":"image/png","href":"/favicon/logo-square-24x24.png","sizes":"24x24"},{"rel":"icon","type":"image/png","href":"/favicon/logo-square-32x32.png","sizes":"32x32"},{"rel":"icon","type":"image/png","href":"/favicon/logo-square-48x48.png","sizes":"48x48"},{"rel":"icon","type":"image/vnd.microsoft.icon","href":"/favicon/logo-square-icon-64.ico"},{"rel":"apple-touch-icon-precomposed","href":"/favicon/logo-square-57x57.png"},{"rel":"apple-touch-icon-precomposed","sizes":"72x72","href":"/favicon/logo-square-72x72.png"},{"rel":"apple-touch-icon-precomposed","sizes":"114x114","href":"/favicon/logo-square-114x114.png"},{"rel":"apple-touch-icon-precomposed","sizes":"144x144","href":"/favicon/logo-square-144x144.png"}],"style":[],"script":[{"hid":"init","src":"/nr-telemetry.js","defer":true,"type":"text/javascript"},{"src":"https://telemetry.nuinalp.com/script.js","tagPosition":"bodyClose","async":true,"data-website-id":"daa394c3-8b94-4e0d-86f5-628d74434246"},{"src":"https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=onloadTurnstileCallback","tagPosition":"head","async":true,"defer":true}],"noscript":[],"title":"Nuinalp Help Centre","titleTemplate":"%s | Nuinalp Help Centre","htmlAttrs":{"lang":"en"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true